import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Chip } from "@mui/material";
import { APP_COLORS } from "../../../../enums";
import { ExpiredTimeChipProps } from "./types";

export function ExpiredTimeChip({ dateLabel, timeLabel }: ExpiredTimeChipProps) {
  return (
    <Chip
      size="small"
      color="error"
      variant="outlined"
      disabled
      icon={<AccessTimeOutlinedIcon sx={{ fontSize: "14px !important" }} />}
      label={`${dateLabel} · ${timeLabel}`}
      sx={{
        height: 28,
        borderRadius: 1,
        fontSize: 11,
        fontWeight: 500,
        borderColor: APP_COLORS.error,
        opacity: 1,
        "&.Mui-disabled": {
          opacity: 1,
          borderColor: APP_COLORS.error,
        },
        "& .MuiChip-label": { px: 0.75 },
        "& .MuiChip-icon": { ml: 0.75, color: "error.main" },
      }}
    />
  );
}
